import * as serviceWorker from './serviceWorker'
import { registerWidgets } from 'widgets/registerWidgets'
import './i18n'

if (process.env.REACT_APP_MOCK === 'mocking') {
  const { worker } = require('./mocks/browser')
  worker.start().then(() => registerWidgets())
} else {
  registerWidgets()

  // If you want your app to wsork offline and load faster, you can change
  // unregister() to register() below. Note this comes with some pitfalls.
  // Learn more about service workers: https://bit.ly/CRA-PWA
  serviceWorker.unregister()
}
